import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";
import DirectoryPicker from "../components/shared/DirectoryPicker";

// Connects to data-controller="embedding-group-picker"
// Intended to be used on a text input containing JSON (Array von
// Directory-Einträgen) — analog zum permission-picker: das Input wird versteckt
// und durch einen groups-only-DirectoryPicker (React-Island) ersetzt.
//
// Beim Submit werden für die ausgewählten Gruppen die sessionStorage-Marker des
// ai-embedding-status-Controllers gesetzt, damit die frisch freigeschalteten
// Gruppen nach dem Redirect sofort ihren Backfill-Fortschritt pollen.
export default class extends Controller {
  static targets = ["input", "submit"];
  static values = { placeholder: String };

  connect() {
    this.originalType = this.inputTarget.type;
    this.inputTarget.type = "hidden";

    const container = document.createElement("div");
    this.inputTarget.insertAdjacentElement("afterend", container);
    this.root = createRoot(container);

    this.element.addEventListener("submit", this.markStartedGroups);
    this.handleChange(JSON.parse(this.inputTarget.value || "[]"));
  }

  disconnect() {
    this.element.removeEventListener("submit", this.markStartedGroups);
    if (this.root) {
      this.root.unmount();
      this.inputTarget.type = this.originalType;
    }
  }

  handleChange = (newValue) => {
    const value = newValue ? [...newValue] : [];
    this.inputTarget.value = JSON.stringify(value);
    if (this.hasSubmitTarget) this.submitTarget.disabled = value.length === 0;

    this.root.render(
      <QueryClientProvider>
        <DirectoryPicker
          value={value}
          onChange={this.handleChange}
          multi
          query={{ groups_only: true }}
          placeholder={this.placeholderValue}
        />
      </QueryClientProvider>,
    );
  };

  markStartedGroups = () => {
    try {
      JSON.parse(this.inputTarget.value || "[]").forEach((entry) => {
        sessionStorage.setItem(
          `ka-embedding-running:${entry.id}`,
          JSON.stringify({ group: true, ts: Date.now() }),
        );
      });
    } catch {
      // ohne Marker pollt die neue Gruppe nach dem Redirect einfach nicht los
    }
  };
}
